import { render } from "./NewLocation.vue?vue&type=template&id=af43685c&scoped=true"
import script from "./NewLocation.vue?vue&type=script&lang=js"
export * from "./NewLocation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-af43685c"

export default script